<template lang="pug">
    div.vibe-controls__group-item( :class="{ 'vibe-controls__group-item--disabled' : disabled }" )
        div
            span.vibe-controls__label Duration: {{ settings.duration }}
            input.vibe-controls__weak-magnitude( type="range" v-model="settings.duration" min="100" max="2000" value="1" step="50" :disabled="false" ) 
        div
            span.vibe-controls__label Weak Motor: {{ Math.round( settings.weakMagnitude * 100 ) }}%
            input.vibe-controls__weak-magnitude( type="range" v-model="settings.weakMagnitude" min="0" max="1" value="1" step="0.05" :disabled="false" ) 
        div
            span.vibe-controls__label Strong Motor: {{ Math.round( settings.strongMagnitude * 100 ) }}%
            input.vibe-controls__strong-magnitude( type="range" v-model="settings.strongMagnitude" min="0" max="1" value="1" step="0.05" :disabled="false" ) 
        div.vibe-controls__group-label Was showing the Index
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Vibe",
        props: {
            disabled: Boolean,
            value: Object
        },
        data() {
            return {
                settings: {
                    duration: this.value ? this.value.duration : 300,
                    weakMagnitude: this.value ? this.value.weakMagnitude : 1,
                    strongMagnitude: this.value ? this.value.strongMagnitude : 1
                }
            }
        },
        watch: {
            settings: {
                handler(val){
                    this.updateValues();
                },
                deep: true
            },
            disabled() {
                this.updateValues();
            }
        },
        methods: {
            updateValues(e) {
                this.$emit('input', this.settings);
            }
        }
    }
</script>